import styled from '@emotion/styled';
import LinearProgressMUI from '@material-ui/core/LinearProgress';
import { css } from 'emotion';

import { colors } from '@cobliteam/base-components/src/styles/colors';

export const progressBar = css`
  z-index: 0;
`;

export const buttonSkip = css`
  color: white;
  font-weight: 500;
  margin-right: 20px;
  background-color: transparent;
  border-color: white;
`;

export const buttonBack = css`
  color: ${colors.primary.default};
  background-color: white;
  padding: 5px 20px;
  &:hover {
    color: white;
  }
`;

export const progressBarContainer = css`
  position: fixed;
  z-index: 99999;
  width: 100%;
`;

export const LinearProgress = styled(LinearProgressMUI)`
  height: 7px;
  background-color: ${colors.primary.disabled};

  & > .MuiLinearProgress-barColorPrimary {
    background-color: ${colors.primary.hover};
  }
`;
